<template>
  <div>
    <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex lg12>
        <v-card>
          <hpo-filter :headers="headers" :viewName="viewName" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
          <v-data-table :headers="headers" :items="items" :options.sync="pagination" :server-items-length="total_rows"
            :footer-props="items_per_page" :must-sort="true" :loading="loading" :mobile-breakpoint="100">
            <template v-slot:item="{ item }">
              <tr>
                <td><code>{{ item.OrderCode }}</code></td>
                <td><v-chip label small outlined color="primary" v-if="item.LicensePlate">{{ item.LicensePlate }}</v-chip></td>
                <td>
                  <div class="font-weight-medium">{{ item.CustomerCode }}</div>
                  <div class="caption grey--text">{{ item.CustomerName }}</div>
                </td>
                <td>{{ item.ProductNameVN }}</td>
                <td>{{ item.ProductNameEN }}</td>
                <td><code>{{ item.HsCode }}</code></td>
                <td>{{ item.Brand }}</td>
                <td>{{ item.Model }}</td>
                <td>{{ item.Unit }}</td>
                <td class="text-right">{{ item.Quantity }}</td>
                <td class="text-right">{{ item.PriceVND | currency('', 0) }}</td>
                <td>
                  <v-chip small :color="getStatusColor(item.OrderStatus)" dark>
                    {{ getStatusName(item.OrderStatus) }}
                  </v-chip>
                </td>
                <td><v-icon medium class="mr-1" @click="openOrder(item.OrderID)">open_in_new</v-icon></td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
    <v-dialog v-model="dialogImport" max-width="560px">
      <v-card>
        <v-card-title class="subtitle-1 font-weight-bold py-3 px-5">
          <v-icon left color="primary">file_upload</v-icon>
          Import hàng hóa CN từ Excel
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-4 px-5 pb-2">
          <v-autocomplete
            label="Đơn hàng CN *"
            v-model="importForm.orderId"
            :items="importOrders"
            item-value="ID"
            :item-text="orderDisplay"
            clearable
            outlined
            dense
            prepend-inner-icon="assignment"
            class="mb-2"
          ></v-autocomplete>
          <v-file-input
            label="File Excel (.xlsx, .xls) *"
            accept=".xlsx,.xls"
            v-model="importForm.file"
            @change="onImportFileChange"
            outlined
            dense
            prepend-icon=""
            prepend-inner-icon="table_chart"
            class="mb-2"
          ></v-file-input>
          <v-alert v-if="excelHeaders.length > 0" dense text type="success" class="mb-0" icon="check_circle">
            Đọc được <strong>{{ excelRows.length }}</strong> dòng dữ liệu.
            <span v-if="mappingAutoApplied"> Đã áp dụng mapping cột đã lưu.</span>
          </v-alert>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="px-5 py-3">
          <v-btn text small color="grey darken-1" :disabled="!excelHeaders.length" @click="openMappingDialog">
            <v-icon small left>tune</v-icon> Match cột
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn text color="grey darken-1" @click="closeImportDialog">Đóng</v-btn>
          <v-btn color="primary" :loading="importing" :disabled="!importForm.orderId || !excelHeaders.length" @click="startImport">
            <v-icon left small>file_upload</v-icon> Import
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogColumnMapping" max-width="700px" persistent>
      <v-card>
        <v-card-title class="subtitle-1 font-weight-bold py-3 px-5">
          <v-icon left color="primary">tune</v-icon>
          Match cột dữ liệu Excel
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="px-5 pt-4 pb-1">
          <v-alert dense text type="info" class="mb-4" icon="info">
            Các cột có dấu <strong class="red--text">*</strong> là bắt buộc. Để trống các cột không có trong file.
          </v-alert>
          <v-row dense>
            <v-col v-for="field in mappingFields" :key="field.key" cols="12" sm="6">
              <v-select
                :label="field.label + (field.required ? ' *' : '')"
                v-model="columnMapping[field.key]"
                :items="excelHeaders"
                clearable
                dense
                outlined
                hide-details="auto"
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider class="mt-3"></v-divider>
        <v-card-actions class="px-5 py-3">
          <v-spacer></v-spacer>
          <v-btn text color="grey darken-1" @click="dialogColumnMapping = false">Hủy</v-btn>
          <v-btn color="primary" @click="confirmColumnMapping">
            <v-icon left small>save</v-icon> Lưu mapping
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import configs from '@/configs'
import Filtering from '@/components/Filtering'
import _ from 'lodash'
import * as XLSX from 'xlsx'
import ApiService from '@/services/api.service'
import { sendErrorNotice, sendSuccessNotice } from '@/commons/utils'

const IMPORT_MAPPING_STORAGE_KEY = 'cn_product_import_mapping_v1'

export default {
  name: 'CnProductList',
  components: {
    'hpo-filter': Filtering
  },
  data() {
    return {
      headers: [
        { text: 'Mã đơn hàng', value: 'OrderCode', sortable: true, filterable: true, quickSearch: true, dataType: configs.DATA_TYPE['String'] },
        { text: 'Biển số xe', value: 'LicensePlate', sortable: true, filterable: true, quickSearch: true, dataType: configs.DATA_TYPE['String'] },
        { text: 'Khách hàng', value: 'CustomerName', sortable: true, filterable: true, quickSearch: true, dataType: configs.DATA_TYPE['String'] },
        { text: 'Tên hàng VN / 越南品名', value: 'ProductNameVN', sortable: true, filterable: true, quickSearch: true, dataType: configs.DATA_TYPE['String'] },
        { text: 'Tên hàng EN / 英文品名', value: 'ProductNameEN', sortable: true, filterable: true, dataType: configs.DATA_TYPE['String'] },
        { text: 'HS Code', value: 'HsCode', sortable: true, filterable: true, quickSearch: true, dataType: configs.DATA_TYPE['String'] },
        { text: 'Nhãn hiệu / 品牌', value: 'Brand', sortable: true, filterable: true, dataType: configs.DATA_TYPE['String'] },
        { text: 'Model / 型号', value: 'Model', sortable: true, filterable: true, dataType: configs.DATA_TYPE['String'] },
        { text: 'Đơn vị / 计量单位', value: 'Unit', sortable: false, filterable: false },
        { text: 'Số lượng / 数量', value: 'Quantity', sortable: true, filterable: true, dataType: configs.DATA_TYPE['Number'], align: 'right' },
        { text: 'Đơn giá / 越南盾', value: 'PriceVND', sortable: true, filterable: true, dataType: configs.DATA_TYPE['Number'], align: 'right' },
        { text: 'Trạng thái', value: 'OrderStatus', sortable: true, filterable: true, dataType: configs.DATA_TYPE['Number'] },
        { text: 'Thao tác', value: 'actions', sortable: false, filterable: false },
      ],
      viewName: 'cn_product_list',
      statusList: configs.CN_ORDER_STATUS_LIST,
      pagination: _.cloneDeep(configs.PAGINATION),
      items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
      filterConditions: [],
      quickFilterConditions: [],
      dialogImport: false,
      dialogColumnMapping: false,
      importing: false,
      importOrders: [],
      importForm: {
        orderId: null,
        file: null
      },
      excelHeaders: [],
      excelRows: [],
      currentHeaderSignature: '',
      mappingAutoApplied: false,
      columnMapping: {},
      mappingFields: [
        { key: 'ProductNameVN', label: 'Tên hàng VN', required: true, aliases: ['tên hàng vn', 'ten hang vn', 'productnamevn'] },
        { key: 'ProductNameEN', label: 'Tên hàng EN', aliases: ['tên hàng en', 'ten hang en', 'productnameen'] },
        { key: 'HsCode', label: 'HS Code', aliases: ['hs code', 'hscode', 'mã hs', 'ma hs'] },
        { key: 'Brand', label: 'Nhãn hiệu', aliases: ['nhãn hiệu', 'nhan hieu', 'brand'] },
        { key: 'Model', label: 'Model', aliases: ['model'] },
        { key: 'Unit', label: 'Đơn vị', aliases: ['đơn vị', 'don vi', 'unit'] },
        { key: 'Quantity', label: 'Số lượng', required: true, number: true, aliases: ['số lượng', 'so luong', 'quantity', 'sl'] },
        { key: 'PriceVND', label: 'Đơn giá (VND)', required: true, number: true, aliases: ['giá vnd', 'gia vnd', 'pricevnd', 'vnd', 'đơn giá', 'don gia'] },
        { key: 'MaterialComposition', label: 'Thành phần', aliases: ['thành phần', 'thanh phan', 'materialcomposition'] },
        { key: 'Specifications', label: 'Quy cách', aliases: ['quy cách', 'quy cach', 'specifications'] },
        { key: 'FunctionUse', label: 'Công dụng', aliases: ['công dụng', 'cong dung', 'functionuse'] },
        { key: 'ManufacturerName', label: 'Nhà sản xuất', aliases: ['nhà sản xuất', 'nha san xuat', 'manufacturername'] },
        { key: 'ExternalDimension', label: 'Kích thước', aliases: ['kích thước', 'kich thuoc', 'externaldimension'] },
        { key: 'CountryOfOrigin', label: 'Xuất xứ', aliases: ['xuất xứ', 'xuat xu', 'countryoforigin'] },
        { key: 'SerialNumber', label: 'Số seri', aliases: ['số seri', 'so seri', 'serialnumber'] },
        { key: 'NetWeightPerPiece', label: 'NET.W/PCS', number: true, aliases: ['net.w/pcs', 'net w/pcs', 'netweightperpiece'] }
      ]
    }
  },

  computed: {
    ...mapState({
      items: state => state.cnOrderProduct.all.data,
      total_rows: state => state.cnOrderProduct.all.total,
      loading: state => state.cnOrderProduct.loading
    })
  },

  watch: {
    pagination: {
      handler: function () {
        let filterConditions = this.$store.state.commons.filterConditions
        this.filterConditions = filterConditions && filterConditions[this.viewName] ? filterConditions[this.viewName] : []
        this.filter_data()
      },
      deep: true
    }
  },

  mounted() {
    this.$root.$emit('REQUEST_ROOT_OPTION', {})
    this.$root.$on('REQUEST_REFRESH_DATA', this.filter_data)
    this.$root.$on('REQUEST_IMPORT_DATA', this.openImportDialog)
  },

  beforeDestroy() {
    this.$root.$off('REQUEST_REFRESH_DATA', this.filter_data)
    this.$root.$off('REQUEST_IMPORT_DATA', this.openImportDialog)
  },

  methods: {
    applyFilter(filterConditions) {
      let sortBy = this.pagination.sortBy
      let sortDesc = this.pagination.sortDesc
      this.pagination = _.cloneDeep(configs.PAGINATION)
      this.pagination.sortBy = sortBy
      this.pagination.sortDesc = sortDesc
      this.filterConditions = filterConditions
      this.filter_data()
    },
    quickFilter(filterConditions) {
      this.quickFilterConditions = filterConditions
      this.filter_data()
    },
    filter_data() {
      this.$store.dispatch('cnOrderProduct/getList', {
        pagination: this.pagination,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions
      })
    },
    getStatusColor(status) {
      const found = this.statusList.find(s => s.value === Number(status))
      return found ? found.color : '#808080'
    },
    getStatusName(status) {
      const found = this.statusList.find(s => s.value === Number(status))
      return found ? found.name : 'N/A'
    },
    openOrder(orderId) {
      this.$router.push({ name: 'CnOrderDetail', params: { Pid: orderId } })
    },
    orderDisplay(order) {
      return `${order.OrderCode || 'N/A'} - ${order.CustomerCode || ''} ${order.CustomerFullName || order.CustomerName || ''}`.trim()
    },
    async openImportDialog() {
      this.dialogImport = true
      this.mappingAutoApplied = false
      this.importForm.file = null
      this.excelHeaders = []
      this.excelRows = []
      this.currentHeaderSignature = ''
      this.columnMapping = {}
      await this.loadOrderOptions()
    },
    closeImportDialog() {
      this.dialogImport = false
      this.dialogColumnMapping = false
    },
    async loadOrderOptions() {
      if (this.importOrders.length > 0) return
      try {
        const res = await ApiService.query('/api/cn-orders/', {
          page: 1,
          rowsPerPage: 100000,
          sortBy: 'ID',
          descending: false
        })
        this.importOrders = (res.data && res.data.data) ? res.data.data : []
      } catch (e) {
        sendErrorNotice('Không tải được danh sách đơn hàng CN.')
      }
    },
    async onImportFileChange(file) {
      if (!file) {
        this.excelHeaders = []
        this.excelRows = []
        this.currentHeaderSignature = ''
        this.columnMapping = {}
        this.mappingAutoApplied = false
        return
      }
      await this.parseExcelFile(file)
    },
    parseExcelFile(file) {
      return new Promise((resolve) => {
        const reader = new FileReader()
        reader.onload = (e) => {
          try {
            const data = new Uint8Array(e.target.result)
            const workbook = XLSX.read(data, { type: 'array' })
            const firstSheet = workbook.SheetNames[0]
            if (!firstSheet) {
              sendErrorNotice('File Excel không có sheet dữ liệu.')
              resolve()
              return
            }
            const worksheet = workbook.Sheets[firstSheet]
            const raw = XLSX.utils.sheet_to_json(worksheet, { header: 1, defval: '' })
            if (!raw || raw.length < 2) {
              sendErrorNotice('File Excel không có dữ liệu để import.')
              resolve()
              return
            }

            const headers = (raw[0] || []).map((h, idx) => {
              const text = String(h || '').trim()
              return text || `COL_${idx + 1}`
            })
            const rows = raw.slice(1).filter(r => Array.isArray(r) && r.some(v => String(v || '').trim() !== ''))
            const rowsAsObject = rows.map(r => {
              const rowObj = {}
              headers.forEach((h, idx) => {
                rowObj[h] = r[idx]
              })
              return rowObj
            })

            this.excelHeaders = headers
            this.excelRows = rowsAsObject
            this.currentHeaderSignature = this.buildHeaderSignature(headers)

            const guessed = this.guessMapping(headers)
            const saved = this.getSavedMappingProfile()
            if (saved && saved.signature === this.currentHeaderSignature && this.isMappingUsable(saved.mapping)) {
              this.columnMapping = { ...guessed, ...saved.mapping }
              this.mappingAutoApplied = true
              this.dialogColumnMapping = false
            } else {
              this.columnMapping = guessed
              this.mappingAutoApplied = false
              this.dialogColumnMapping = true
            }
          } catch (err) {
            sendErrorNotice('Không đọc được file Excel. Vui lòng kiểm tra lại định dạng file.')
          }
          resolve()
        }
        reader.readAsArrayBuffer(file)
      })
    },
    openMappingDialog() {
      if (!this.excelHeaders.length) {
        sendErrorNotice('Vui lòng chọn file Excel trước.')
        return
      }
      this.dialogColumnMapping = true
    },
    confirmColumnMapping() {
      const missing = this.mappingFields
        .filter(f => f.required)
        .filter(f => !this.columnMapping[f.key])
      if (missing.length > 0) {
        sendErrorNotice(`Thiếu map cột bắt buộc: ${missing.map(m => m.label).join(', ')}`)
        return
      }
      this.saveMappingProfile()
      this.mappingAutoApplied = true
      this.dialogColumnMapping = false
      sendSuccessNotice('Đã lưu mapping cột dữ liệu.')
    },
    normalizeHeader(value) {
      return String(value || '')
        .trim()
        .toLowerCase()
        .replace(/[_-]/g, ' ')
        .replace(/\s+/g, ' ')
    },
    buildHeaderSignature(headers) {
      return (headers || []).map(h => this.normalizeHeader(h)).join('|')
    },
    guessMapping(headers) {
      const mapping = {}
      const normalizedHeaderMap = {}
      headers.forEach(h => {
        normalizedHeaderMap[this.normalizeHeader(h)] = h
      })

      this.mappingFields.forEach(field => {
        const candidates = [field.label, field.key, ...(field.aliases || [])]
          .map(a => this.normalizeHeader(a))

        let matched = null
        for (let i = 0; i < candidates.length; i++) {
          const candidate = candidates[i]
          const exact = Object.keys(normalizedHeaderMap).find(k => k === candidate)
          if (exact) {
            matched = normalizedHeaderMap[exact]
            break
          }
          const partial = Object.keys(normalizedHeaderMap).find(k => k.includes(candidate) || candidate.includes(k))
          if (partial) {
            matched = normalizedHeaderMap[partial]
            break
          }
        }
        if (matched) {
          mapping[field.key] = matched
        }
      })
      return mapping
    },
    getSavedMappingProfile() {
      try {
        const raw = localStorage.getItem(IMPORT_MAPPING_STORAGE_KEY)
        return raw ? JSON.parse(raw) : null
      } catch (e) {
        return null
      }
    },
    saveMappingProfile() {
      const payload = {
        signature: this.currentHeaderSignature,
        mapping: this.columnMapping,
        updatedAt: new Date().toISOString()
      }
      localStorage.setItem(IMPORT_MAPPING_STORAGE_KEY, JSON.stringify(payload))
    },
    isMappingUsable(mapping) {
      if (!mapping || !this.excelHeaders.length) return false
      return Object.values(mapping).every(header => !header || this.excelHeaders.includes(header))
    },
    toNumber(value) {
      if (value === null || value === undefined || value === '') return 0
      const normalized = String(value).replace(/,/g, '').trim()
      const parsed = parseFloat(normalized)
      return Number.isNaN(parsed) ? 0 : parsed
    },
    mapExcelRowToPayload(row) {
      const payload = {}
      this.mappingFields.forEach(field => {
        const source = this.columnMapping[field.key]
        if (!source) return
        const rawValue = row[source]
        if (field.number) {
          payload[field.key] = this.toNumber(rawValue)
        } else {
          payload[field.key] = String(rawValue || '').trim()
        }
      })
      return payload
    },
    isEmptyMappedRow(payload) {
      return Object.keys(payload).length === 0 || Object.values(payload).every(v => v === '' || v === 0 || v === null || v === undefined)
    },
    async startImport() {
      if (!this.importForm.orderId) {
        sendErrorNotice('Vui lòng chọn đơn hàng cần import.')
        return
      }
      if (!this.importForm.file || !this.excelRows.length) {
        sendErrorNotice('Vui lòng chọn file Excel hợp lệ.')
        return
      }

      const missing = this.mappingFields
        .filter(f => f.required)
        .filter(f => !this.columnMapping[f.key])
      if (missing.length > 0) {
        this.dialogColumnMapping = true
        sendErrorNotice('Vui lòng match đủ các cột bắt buộc trước khi import.')
        return
      }

      // Build list of valid (non-empty) rows
      const products = []
      const clientErrors = []
      for (let i = 0; i < this.excelRows.length; i++) {
        const row = this.excelRows[i]
        const payload = this.mapExcelRowToPayload(row)
        if (this.isEmptyMappedRow(payload)) continue
        if (!payload.ProductNameVN || this.toNumber(payload.Quantity) <= 0) {
          clientErrors.push(`Dòng ${i + 2}: Thiếu tên hàng hoặc số lượng không hợp lệ.`)
          continue
        }
        payload.Quantity = this.toNumber(payload.Quantity)
        if (payload.PriceVND !== undefined) payload.PriceVND = this.toNumber(payload.PriceVND)
        if (payload.NetWeightPerPiece !== undefined) payload.NetWeightPerPiece = this.toNumber(payload.NetWeightPerPiece)
        products.push(payload)
      }

      if (products.length === 0 && clientErrors.length === 0) {
        sendErrorNotice('Không có dòng dữ liệu nào để import.')
        return
      }

      this.importing = true
      try {
        const res = await ApiService.post(
          `/api/cn-orders/${this.importForm.orderId}/products/bulk-import/`,
          { products }
        )
        const data = res && res.data && res.data.data ? res.data.data : {}
        const successCount = data.success_count || 0
        const apiErrors = (data.errors || []).map(e => `Dòng ${e.row}: ${e.reason}`)
        const allErrors = [...clientErrors, ...apiErrors]

        if (successCount > 0) {
          this.saveMappingProfile()
          this.filter_data()
          sendSuccessNotice(`Import thành công ${successCount} sản phẩm.`)
        }
        if (allErrors.length > 0) {
          sendErrorNotice(`Có ${allErrors.length} dòng lỗi:\n${allErrors.slice(0, 5).join('\n')}`)
        }
        if (successCount > 0 && allErrors.length === 0) {
          this.closeImportDialog()
        }
      } catch (e) {
        const reason = (e && e.body && e.body.reason)
          ? e.body.reason
          : (e && e.response && e.response.data && e.response.data.reason)
            ? e.response.data.reason
            : 'Lỗi kết nối hoặc server không phản hồi.'
        sendErrorNotice(`Import thất bại: ${reason}`)
      } finally {
        this.importing = false
      }
    }
  }
}
</script>
